import React, { useEffect, useState } from "react";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { formatDate, ToastMain ,SweetAlertShow} from "../master/Master";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HostelFeesPay, HostelFeesCollection, HostelFeesCollectionNew } from "../../api/HostelService";
import WelcomeBar from "./WelcomeBar";
import { BankList } from "../../api/BankService";


export default function FeesPay() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const student = queryParams.get("student_id");
  const hostel = queryParams.get('hostel_id')
  const [hostelList, setHostelList] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [amountInput, setAmountInput] = useState('');
   const [Banks, setBanks] = useState([]);

     const getBusinessBanks = async () => {
        setLoading(true)
        try {
          const response = await BankList();
          if (response?.data?.status) {
            setBanks(response?.data?.data)
          } else {
            // ToastMain.fire({
            //   icon: 'info',
            //   title: response?.data?.message || 'something went wrong'
            // })

            SweetAlertShow('info','Warning',response?.data?.message)
          }
    
        } catch (error) {
          // ToastMain.fire({
          //   icon: 'error',
          //   title: error?.response?.data?.message || 'something went wrong'
          // })

          SweetAlertShow('error','Error',error?.response?.data?.message)
        } finally {
          setLoading(false)
        }
      }

         useEffect(()=>{
            getBusinessBanks();
          },[]);

  const HostelFees = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await HostelFeesPay(formData);
      if (response?.data?.status) {
        setError('')
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        }).then(() => {
          navigate("/hostel/fees/deposit");
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors)
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors)
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };
  const getHostelStudent = async () => {
    setLoading(true);
    let addUrl = `&id=${id}&student_id=${student}&hostel_id=${hostel}`;

    try {
      const response = await HostelFeesCollectionNew(addUrl);
      if (response.data.status) {
        setHostelList(response?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
      SweetAlertShow('error','Error', error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getHostelStudent();
  }, [id]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper p-4">
              <div className="container-fluid">
                <WelcomeBar />
                <div className="d-flex align-content-center justify-content-between border-bottom my-3">
                  {/* <div className="">
                    <h4 className="fw-bold text-primary mb-0">
                      💳 Deposit Fee ({hostelList?.hostel_student?.hostel?.name})
                      ({hostelList?.hostel_student?.student_name})
                    </h4>
                    <p className="text-muted">
                      Review fee summary and submit new deposit details.
                    </p>
                  </div> */}
                  <div className="text-end">
                    <Link to={"/hostel/fees/deposit"} className="btn btn-sm btn-label-primary">

                      Go Back</Link>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-5 border-end">

                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="fw-bold text-center" colSpan={2}>
                                  Fee Summary
                                </th>
                              </tr>
                            </thead>
                            <tbody>

                              <tr>
                                <th>Hostel Fee</th>
                                <td>₹{hostelList?.data?.final_fee || "0"}/M</td>
                              </tr>
                              {hostelList?.data?.advance_fee == 0 && (
                                <tr className="table-danger">
                                  <th>Left Amount</th>
                                  <td className="text-danger">{hostelList?.data?.hostel_left_amount}</td>
                                </tr>
                              )}

                              {hostelList?.data?.advance_fee > 0 && (
                                <tr className="table-success">
                                  <th>Advance Fee</th>
                                  <td> <span className="text-success">{hostelList?.data?.advance_fee}</span> </td>
                                </tr>
                              )}


                              <tr className="">
                                <th>Last pay</th>
                                <td>
                                  <span className="text-danger fw-bold">
                                    ₹{hostelList?.left_amount || "0"}
                                  </span>
                                </td>
                              </tr>

                              {/* Last Transaction Details */}
                              {Array.isArray(hostelList?.data?.hostel_fees_transaction) &&
                                hostelList.data.hostel_fees_transaction.length > 0 && (
                                  <>
                                  <tr>
                                      <th>Last Payment Date</th>
                                      <td>
                                        {
                                          hostelList.data.hostel_fees_transaction.at(-1)
                                            ?.payment_date
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Last Paid Amount</th>
                                      <td>
                                        ₹
                                        {
                                          hostelList.data.hostel_fees_transaction.at(-1)
                                            ?.amount
                                        }
                                      </td>
                                    </tr>
                                    
                                    
                                  </>
                                )}
                            </tbody>
                          </table>
                        </div>

                      </div>
                      <div className="col-md-7">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="fw-bold text-center">
                                  Deposit Hostel Payment
                                </th>
                              </tr>
                            </thead>
                          </table>
                          <form className="row g-4 mt-1" onSubmit={HostelFees}>
                            {id && <input type="hidden" name="id" value={id} />}
                            <input type="hidden" name="student_id"  value={hostelList?.data?.student_id} />

                            <div className="col-md-6 mb-3">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={amountInput}
                                  onChange={(e) => setAmountInput(parseInt(e.target.value) || 0)}
                                  required
                                  name="amount"
                                  step="0.01"
                                />
                                <label>
                                  Amount <span className="text-danger">*</span>
                                </label>
                                <span className="text-danger">{error?.amount ?? ''}</span>
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              {/* <div className="form-floating form-floating-outline">
                                <select
                                  name="method"
                                  className="form-select"
                                  required
                                >
                                  <option value="" selected disabled>
                                    {" "}
                                    Select Method{" "}
                                  </option>
                                  <option value="Cash">Cash</option>
                                  <option value="Online">Online</option>
                                </select>
                                <label>
                                  Payment Method
                                  <span className="text-danger">*</span>
                                </label>
                                <span className="text-danger">{error?.method ?? ''}</span>

                              </div> */}

                              <div className="form-floating form-floating-outline">
                            <select
                              name="bank_id"
                              className="form-select"
                              required
                            >
                              <option selected disabled>Select Banks</option>
                             {Banks?.map((item, index)=>(
                              <option key={item?.id} value={item?.id}>{item?.account_no}:({item?.owner_name}):({item?.id})</option>
                             ))}
                            </select>
                            <label>
                              Select Banks{" "}
                              <span className="text-danger">*</span>{" "}
                            </label>
                          </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Transaction ID"
                                  name="transaction_no"
                                />
                                <label>
                                  Transaction ID{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <span className="text-danger">{error?.transaction_no ?? ''}</span>

                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  name="payment_date"
                                  className="form-control"
                                  defaultValue={
                                    new Date().toISOString().split("T")[0]
                                  }
                                  required
                                />
                                <label>
                                  Payment Date{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <span className="text-danger">{error?.payment_date ?? ''}</span>

                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-uppercase"
                                  placeholder="Any note or comment"
                                  name="remark"
                                />
                                <label>Remark (Optional)</label>
                                <span className="text-danger">{error?.remark ?? ''}</span>

                              </div>
                            </div>
                            <div className="col-12 text-end">
                              <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                ) : (
                                  'Submit'
                                )}
                                {loading ? ' Submitting...' : ''}
                              </button>
                            </div>
                          </form>


                          {/* Advance / Left Calculation */}
                          {/* 3️⃣ Payment Breakdown Card */}
                          <div className="">
                            <div className="">


                              {(() => {
                                const hostelFees = hostelList?.data?.hostel_fees || [];
                                let remainingPayment = amountInput + (parseInt(hostelList?.data?.advance_fee) || 0); // include already advance
                                const advanceDetails = [];

                                for (let fee of hostelFees) {
                                  const left = parseInt(fee.left_amount) || 0;
                                  if (remainingPayment >= left) {
                                    remainingPayment -= left;
                                    advanceDetails.push({
                                      month: fee.month,
                                      paid: left,
                                      remaining: 0,
                                    });
                                  } else {
                                    advanceDetails.push({
                                      month: fee.month,
                                      paid: remainingPayment,
                                      remaining: left - remainingPayment,
                                    });
                                    remainingPayment = 0;
                                  }
                                }

                                return (
                                  <>
                                    <ul>
                                      {advanceDetails.map((adv, idx) => (
                                        <li key={idx} className="text-danger">
                                          {formatDate(new Date(`${adv.month}-01`))}: Paid ₹{adv.paid}, Remaining ₹{adv.remaining}
                                        </li>
                                      ))}
                                    </ul>
                                    {/* {remainingPayment > 0 && (
                                      <p className=" fw-bold">
                                        Total Advance Payment Remaining: ₹
                                        {remainingPayment + (Number(hostelList?.data?.advance_fee) || 0)}
                                      </p>
                                    )} */}

                                  </>
                                );
                              })()}
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
